import ChartMaker from '../factory/gbasechart';
import * as DataManager from '../highchart/highchartData';
import BarChart from '../highchart/barChart';
import ColumnChart from '../highchart/columnChart';
import LineChart from '../highchart/lineChart';
import AreaChart from '../highchart/areaChart';
import PieChart from '../highchart/pieChart';
import BubbleChart from '../highchart/bubbleChart';
import GenreMaker from '../highchart/genreMaker';
import Highcharts from 'highcharts'

var HighChart = class HighChart extends ChartMaker {

    draw(state){

        //$("#container").html("");
        // this.propsToVO(state.props);
        //this.chart = this.createChartByGenre(state.chartInfo);
        //this.setChartProperties();
        var container = state.container;
        //this.chart.container(container);

        function chart3(){
          //var dataType = state.chartInfo.subChart.highdataType;
          var Type = state.chartInfo.subChart.genre[0];
          var dataType = state.chartInfo.subChart.genre[1];
          var container = state.container;
          var data = DataManager.getData(Type,dataType,container);
          //data.title.text = state.props.title.value;
          if(state.chartInfo.chart.genre == "line")
          {
            data.chart.type="line";
            if(dataType=='spline' || dataType=='series_spline')
            {
              data.chart.type="spline";
            }
          }

          if(state.chartInfo.chart.genre == "bar")
          {
            data.chart.type="bar";
            if(dataType=='percent_stacked')
            {
              data.plotOptions={bar:{stacking:'percent'}};
            }

          }

          // if(state.chartInfo.chart.genre == "pie")
          // {
          //   data.chart.type="pie";
          // }
          //
          // if(state.chartInfo.chart.genre == "area")
          // {
          //   data.chart.type="area";
          // }

          var chart = new Highcharts.Chart(data);
        }
        $(function () {
            chart3();
        });
        //this.chart.draw(state);
    }
    };

    ChartMaker.HighChart = HighChart;

    export var HighChart;



// WEBPACK FOOTER //
// ./src/factory/highchart.js